import { AbstractControl, ValidatorFn } from '@angular/forms';
import * as _ from 'lodash';

import { getFieldRequiredValue } from 'utils/scorecard-conditionals';

/*
  Custom required validation for scorecard fields
  
  Example:
  "conditionals": [{
    "path": "packages.EA.quantity",
    "is_required_when": { // this fields are connectedby OR
      "packages.PL.hazardous_materials.0.regulated.regulated": "Y", // value - if we need certain value
      "packages.EA.hazardous_materials.0.regulated.description": null, // null - needs to be populated
      "packages.EA.hazardous_materials.0.regulated.shipping_name": null,
      "packages.EA.hazardous_materials.0.regulated.unnaid_code": null,
    },
  }],
*/
export const createScoreFieldRequiredValidation = (rules) => {
  return function (): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
      if (!control.parent) {
        return null;
      }
      const required = getFieldRequiredValue(rules, control.parent.controls);

      if (required && !(control.value && control.value.length)) {
        return { 'required': 'Required' };
      }
      return null;
    };
  };
};
